import React, { useState } from 'react'
import Modal from '../../../../common/modal'
import { Box, Button} from '@mui/material'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
const PartyRequestCancelRemark = ({ updateModal, setShowModel, sendOTPRequest, handleAcceptData, loginData, handleReject,setTextAreaValue,getCargoSettingData }) => {
    const handleRemark = (value) => {
        setTextAreaValue(value)
    }
    const handleSave = () => {
        if (getCargoSettingData[0].IsRechargeApprovalOTP===0) {
            // reject API call
            handleReject()
        } else {
            sendOTPRequest(handleAcceptData?.PartyID)
        }
        setShowModel(false)
    }
    return (
        <Modal headTxt={`Recharge Request Cancel Remark`} width={'50%'} updateModal={updateModal}>
            <Box style={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'column', margin: '15px' }}>
                <Box sx={{ display: 'inline-flex', padding: '0% 0px', height: '100px', marginBottom: '10px' }}>
                    <textarea
                        className="ticket-textarea"
                        id="rulesInput"
                        name="rulesInput"
                        // value={selectedFormtatData.RulesAndRegulations || ''}
                        onChange={(e) => handleRemark(e.target.value)}
                        rows="10"
                        placeholder="Type Your Remarks here..."
                        style={{
                            width: '100%',
                            boxSizing: 'border-box',
                            borderRadius: '6px',
                            borderColor: '#00000026',
                            padding: '15px',
                            fontFamily: 'Roboto',
                            fontSize: '14px',
                            fontWeight: '500',
                            color: '#444444',
                            // borderColor: borderColor,
                        }}
                    // onKeyDown={(e) => navigation1(e, 'declaration', 'website')}
                    // onFocus={handleFocus}
                    // onBlur={handleBlur}
                    />
                </Box>
                <Item sx={sx.itemsx} style={{ textAlign: 'right' }}>
                    <Button variant="contained" className="go click-button" onClick={handleSave}>
                        SAVE
                    </Button>
                </Item>
            </Box>
        </Modal>
    )
}

export default PartyRequestCancelRemark